import React from 'react';

function Divider() {
  return (
    <div className="skills-divider">
      <span></span>
    </div>
  );
}

export default Divider;
